import { createSlice } from "@reduxjs/toolkit";
import { getDominanciaTalentosThunk } from "./dominanciaTalentos.thunks";

const initialState = {
  dominanciaTalentos: [],
  loading: false,
  error: null,
};

const dominanciaTalentosSlice = createSlice({
  name: "dominanciaTalentos",
  initialState,
  reducers: {
    clearDominanciaError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDominanciaTalentosThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDominanciaTalentosThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.dominanciaTalentos = action.payload;
      })
      .addCase(getDominanciaTalentosThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDominanciaError } = dominanciaTalentosSlice.actions;
export default dominanciaTalentosSlice.reducer;
